import { SUPPORTED_LANGUAGES, RTL_LANGUAGES } from './languages';

// Map a host locale to a supported i18n code, mirroring CRM's convention:
// base codes are lowercase ('en', 'ar'); region variants are lowercase-base + '_' +
// UPPERCASE region ('en-AU' or 'en_au' -> 'en_AU', à la CRM's 'en_MY'). The matching
// bundle file is '<base>-<region>.json' (e.g. 'en-au.json'). Prefer an exact regional
// match (so a region-specific bundle is used), else the base language, else 'en'.
export const normalizeLocale = (raw?: string | null): string => {
  if (!raw) return 'en';
  const [rawBase, rawRegion] = raw.split(/[-_]/);
  const base = (rawBase || '').toLowerCase();
  const code = rawRegion ? `${base}_${rawRegion.toUpperCase()}` : base;
  if (SUPPORTED_LANGUAGES.includes(code)) return code;
  return SUPPORTED_LANGUAGES.includes(base) ? base : 'en';
};

// RTL is determined by the base language (ar/iw/ur), regardless of region.
export const isLanguageRTL = (lng?: string | null): boolean =>
  RTL_LANGUAGES.includes(normalizeLocale(lng).split('_')[0]);

// RTL is driven by the document dir (antd-mobile + browser honor it).
export const applyDirection = (lng?: string | null): void => {
  document.documentElement.dir = isLanguageRTL(lng) ? 'rtl' : 'ltr';
};
